<template>
  <Drawer title="Search Tools" screen="searchPage" position="left">
    <DxAccordion :collapsible="true"
                 :multiple="false"
                 :selected-index="-1"
                 :focus-state-enabled="false"
                 :width="250"
    >
      <DxItem title="Search with Tags"> <TagFilters/> </DxItem>
      <DxItem title="Search with Folders"> <FolderExplorer/> </DxItem>
      <DxItem title="Search History"> <SearchHistory/> </DxItem>
    </DxAccordion>
  </Drawer>
</template>

<script setup>
  import Drawer from "@/components/base-components/drawer/Drawer.vue";
  import TagFilters from "@/components/base-components/drawer-tools/TagFilter.vue";
  import FolderExplorer from "@/components/base-components/drawer-tools/FolderExplorer.vue";
  import SearchHistory from "@/components/base-components/drawer-tools/SearchHistory.vue";
  import { DxAccordion, DxItem } from "devextreme-vue/accordion";
</script>

<style scoped lang="scss">

</style>
